import { Badge, BadgeSize, BadgeVariant } from "shared/components";

export const NewBadge = ({
  variant,
  className,
  destructAfterDate
}: {
  variant: BadgeVariant;
  className?: string;
  /** ISO 8601 date string; once the current date is past it, the badge is hidden. */
  destructAfterDate?: string;
}) => {
  if (destructAfterDate && new Date() > new Date(destructAfterDate))
    return null;

  return (
    <Badge variant={variant} size={BadgeSize.SM} className={className}>
      New
    </Badge>
  );
};
